// extracted by mini-css-extract-plugin
module.exports = {"notificationsWrapper":"Notifications_notificationsWrapper__35f0y","notificationEmailsWrapper":"Notifications_notificationEmailsWrapper__kghgP"};